import { useCallback, useMemo, forwardRef } from 'react';
import { Link as RouterLink, Navigate as RouterNavigate, useLocation as useRouterLocation, useNavigate as useRouterNavigate } from 'react-router-dom';
import { isViedmaPath, toViedmaPath, toAppPath } from './viedmaPaths.mjs';

export * from 'react-router-dom';

export function useIsViedma() {
  return isViedmaPath(useRouterLocation().pathname);
}

export function useLocation() {
  const location = useRouterLocation();
  return useMemo(() => isViedmaPath(location.pathname)
    ? { ...location, pathname: toAppPath(location.pathname) }
    : location, [location]);
}

export function useNavigate() {
  const navigate = useRouterNavigate();
  const { pathname } = useRouterLocation();
  const scopedNavigate = useCallback((to, options) => navigate(toViedmaPath(to, pathname), options), [navigate, pathname]);
  return isViedmaPath(pathname) ? scopedNavigate : navigate;
}

export const Link = forwardRef(function PortalLink({ to, ...props }, ref) {
  const { pathname } = useRouterLocation();
  return <RouterLink ref={ref} to={toViedmaPath(to, pathname)} {...props} />;
});

export function Navigate({ to, ...props }) {
  const { pathname } = useRouterLocation();
  return <RouterNavigate to={toViedmaPath(to, pathname)} {...props} />;
}
